/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
import { routes } from '@/router';
import { analyticsEventNames, trackEvent } from '@/bublik/features/analytics';
import { ButtonTw, Icon } from '@/shared/tailwind-ui';
import { LinkWithProject } from '@/bublik/features/projects';

export interface LinkToRunProps {
	runId: string;
	targetIterationId?: number | null;
}

export function LinkToRun(props: LinkToRunProps) {
	const { runId, targetIterationId } = props;

	return (
		<ButtonTw asChild variant="secondary" size="xss">
			<LinkWithProject
				to={routes.run({
					runId,
					targetIterationId: targetIterationId ?? undefined
				})}
				onClick={() => {
					trackEvent(analyticsEventNames.logLinkToRunClick, {
						source: 'log_toolbar'
					});
				}}
			>
				<Icon name="BoxArrowRight" className="mr-1.5" />
				Run
			</LinkWithProject>
		</ButtonTw>
	);
}
